import { SKELETON_KEY } from './skeletonFactory';

export function skeletonOperator() {
  return {
    id: SKELETON_KEY,
    name: SKELETON_KEY
  };
}
